import useHttpPost from "./useHttpPost";

export default function usePostWorkType(target){
    return useHttpPost("worktype", "post", {}, target)
}